"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DropdownModule = _interopRequireDefault(require("./Dropdown.module.scss"));

var _DropdownContext = require("./DropdownContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function DropdownToggle(_ref) {
  var nodeId = _ref.nodeId,
      isIcon = _ref.isIcon,
      children = _ref.children;
  var context = (0, _react.useContext)(_DropdownContext.DropdownContext);
  return _react.default.createElement("div", {
    id: nodeId,
    className: isIcon && _DropdownModule.default.icon,
    onClick: context.toggle
  }, children);
}

DropdownToggle.protoType = {
  nodeId: _propTypes.default.string,
  icon: _propTypes.default.bool,
  children: _propTypes.default.node
};
var _default = DropdownToggle;
exports.default = _default;